/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import * as actions from './ChatGptMessage-Actions';

const ChatGptInitalState = {};
const chatGptReducer = (state = ChatGptInitalState, action) => {
    switch (action.type) {
        case actions.updateChatgptGiftMessage().type: {
            const updateChatGptState = { ...state };
            updateChatGptState[action.data.cartItemId] = action.data.chatGptData;
            return updateChatGptState;
        }
        case actions.updateSelectedChatgptGiftMessage().type:
            return {
                ...state,
                selectedMessage: action.data,
            };
        case actions.clearAllChatgptMessage().type:
            return {};
        default:
            return state;
    }
};

export default chatGptReducer;
